var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasteBitterness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TasteBitterness",
    "data-name": "TasteBitterness",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.304
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#fff852"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12621",
    "data-name": "Path 12621",
    d: "M560.429,141.24c-16.633,8.46-14.6,17.635-9.279,29.614s21.587,20.028,30.589,15.31c9.2-4.821,14.458-20.985,9.132-32.965-.314-.707-.644-1.4-1.124-2.332-5.388-10.506-14.995-16.913-29.318-9.628",
    transform: "translate(-515.647 -107.163)",
    fill: "#fffa86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12623",
    "data-name": "Path 12623",
    d: "M560.673,138.363a2.341,2.341,0,0,0-4.2-2.069c-2.9,5.883.882,11.2,1.046,11.43a2.331,2.331,0,0,0,3.248.52,2.347,2.347,0,0,0,.55-3.257c-.095-.132-2.279-3.305-.643-6.624",
    transform: "translate(-513.598 -113.209)",
    fill: "#85564a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12624",
    "data-name": "Path 12624",
    d: "M36.423,8.961c-2.229,1.184-4.342,5.378-5.162,6.63,0,0-1.056-1.114-1.409.8s-.017,6.8-.134,8.217A61.417,61.417,0,0,1,35.386,21.3c3.1-1.59,3.15-4.054,3.735-8.08s-.469-5.445-2.7-4.262",
    transform: "translate(18.463 9.761)",
    fill: "#508034"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12625",
    "data-name": "Path 12625",
    d: "M10717.2,20612.055s1.914,3.051,4.913,1.316,0-4.773,0-4.773Z",
    transform: "translate(-7296.242 -21954.15) rotate(9)",
    fill: "#ebc700",
    stroke: "#ebc700",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteBitterness);
export default __webpack_public_path__ + "static/media/TasteBitterness.04ff0e063f448012a94e61d8d4fe17e4.svg";
export { ForwardRef as ReactComponent };